import { ReactNode } from 'react';

export enum ContainerClass {
  Bodies = "bodies",
  Heads = "heads",
}

export interface Props {
  children?: ReactNode,
  className?: string,
  onSwitch?: () => void,
  hasTeamSuccessTab?: boolean,
  mainTabs?: Array<{ id: number, title: string, content: Array<{ id: number, description: string }> }>,
  tabs?: Array<{title: string, content: string | JSX.Element }>,
}
